







































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import moment from "moment";
import QrcodeVue from 'qrcode.vue';

// Servicios
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { toastService } from '@/services/ToastService';
import  { DecimoService } from '@/services/DecimoService';
import { FiltroService } from '@/services/FiltroService';
import { authService } from '@/services/AuthService';

// Modelo
import { Sorteo } from '@/model/Sorteo';
import { Decimo } from '@/model/Decimo';
import { Filtro } from '@/model/Filtro';
// Componentes
import SorteoFiltrosPopup from './SorteoFiltrosPopup.vue';


@Component({
  components: { 
    SorteoFiltrosPopup,
    QrcodeVue
  },
})
export default class SorteoSacarNumeros extends Vue {
  isAdmin: any;

  decimoService: any | DecimoService = new DecimoService();
  filtroService: any | FiltroService = new FiltroService();
  
  @Prop({ type: Number, default: 0 })
  idSorteo!: number;

  sorteo!: Sorteo;

  @Prop()
  filtro: any | Filtro;
  visibleFiltros: boolean = false;
  nameEventCloseFiltros: string = "FiltrosFormSacarNumeros-Close"
  nameEventSaveFiltros: string = "FiltrosFormSacarNumeros-Save"

  visible: boolean = false;
  unNumeroMas: boolean = false;

  decimo: Decimo | any = {};

  filtrar: boolean = false;

  textoQR: string = "";
  
  iniciarExtraccion(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoSacarNumeros.vue - iniciarExtraccion()");
    this.decimoService.sacar(this.idSorteo, this.filtrar).then((res: any) =>{
      this.visible = true;
      if(res !== null){
        this.decimo = res;
        let fechaSorteo = moment(this.sorteo.FechaCelebracion).format("DDMMMYY").replace(".","").toUpperCase();
        this.textoQR = "P=5;S="+this.sorteo.Numero+fechaSorteo+":1;W=0;N="+this.decimo.Numero+";F=1;SE=1;";

        if(res.Body === null){
          logService.Info("No existe ningún número disponible - Sorteo: "+this.idSorteo,"SorteoSacarNumeros.vue - iniciarExtraccion()");
          toastService.warning("No existe ningún número disponible.");
        }
      }
    })
  }

  created(){
    this.isAdmin = authService.isAdmin();

    eventService.on(this.nameEventCloseFiltros, (obj: any) => {
      this.visibleFiltros = false;
    });

    eventService.on(this.nameEventSaveFiltros, (obj: any) => {
      this.visibleFiltros = false;
      eventService.emit("LoadPanel", true);
      this.filtroService.update(obj).then(() => {
        eventService.emit("LoadPanel", false);
        logService.Info("Filtros de números modificados correctamente - Sorteo: "+this.idSorteo,"SorteoSacarNumeros.vue - created()");
        toastService.success("Filtros de números modificados correctamente.");
      });
    });

    eventService.on("SorteoDetailLoaded", (obj: any) => {
      this.sorteo = obj;
    });
  }

  destroyed(){
    eventService.off(this.nameEventCloseFiltros);
    eventService.off(this.nameEventSaveFiltros);
    eventService.off("SorteoDetailLoaded");
  }

  sacado(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoSacarNumeros.vue - sacado()");
    
    this.decimo.FechaExtraccion = new Date();
    this.decimo.MetodoExtraccion = "FUNCIÓN SACAR NÚMEROS";
    this.decimo.Sacado = true;
    this.decimo.Stock--;

    this.decimoService.update(this.decimo).then((res: Decimo) =>{
      logService.Info("Número sacado correctamente - Numero: "+this.decimo.Numero+" - Sorteo: "+this.idSorteo,"SorteoSacarNumeros.vue - sacado()");
      toastService.success("Número sacado correctamente.");
    })

    if(!this.unNumeroMas){
      this.decimoService.sacar(this.idSorteo, this.filtrar).then((res: Decimo) =>{
        this.decimo = res;
        let fechaSorteo = moment(this.sorteo.FechaCelebracion).format("DDMMMYY").replace(".","").toUpperCase();
        this.textoQR = "P=5;S="+this.sorteo.Numero+fechaSorteo+":1;W=0;N="+this.decimo.Numero+";F=1;SE=1;";
      })
    }else{
      this.unNumeroMas = false;
      this.salir();
    }
  }

  noDisponible(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoSacarNumeros.vue - noDisponible()");
    this.decimo.Stock = 0;

    this.decimoService.update(this.decimo).then((res: Decimo) =>{
      logService.Info("Número modificado correctamente - Numero: "+this.decimo.Numero+" - Sorteo: "+this.idSorteo,"SorteoSacarNumeros.vue - noDisponible()");
      toastService.success("Número modificado correctamente.");
    })

    if(!this.unNumeroMas){
      this.decimoService.sacar(this.idSorteo, this.filtrar).then((res: Decimo) =>{
        this.decimo = res;
        let fechaSorteo = moment(this.sorteo.FechaCelebracion).format("DDMMMYY").replace(".","").toUpperCase();
        this.textoQR = "P=5;S="+this.sorteo.Numero+fechaSorteo+":1;W=0;N="+this.decimo.Numero+";F=1;SE=1;";
      })
    }else{
      this.salir();
    }
  }
  sacarUnNumeroMas(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoSacarNumeros.vue - sacarUnNumeroMas()");
    this.unNumeroMas = true;
  }

  salir(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoSacarNumeros.vue - salir()");
    eventService.emit("GridSacados-Refresh", true);
    this.visible = false;
  }

  onFilter(){
    this.filtrar = !this.filtrar;
    logService.Info("Inicio - Sorteo: "+this.idSorteo+" - Filtrar: "+ this.filtrar,"SorteoSacarNumeros.vue - onFilter()");
  }

  onViewFiltros(){
    this.visibleFiltros = true;
  }

}
